// Auto-generated by scripts/generate-glossary.ts - DO NOT EDIT MANUALLY

export interface GlossaryFile {
  name: string;
  import: () => Promise<string>;
}

export const GLOSSARY_FILES: GlossaryFile[] = [
  {
    name: "1_INTRODUCTION",
    import: async () => {
      const module = await import("../rules/1_INTRODUCTION.md");
      return module.default as string;
    },
  },
  {
    name: "2_CHARACTER_CREATION",
    import: async () => {
      const module = await import("../rules/2_CHARACTER_CREATION.md");
      return module.default as string;
    },
  },
  {
    name: "3.1_STAT_CHECKS",
    import: async () => {
      const module = await import("../rules/3.1_STAT_CHECKS.md");
      return module.default as string;
    },
  },
  {
    name: "3.2_FUDGING",
    import: async () => {
      const module = await import("../rules/3.2_FUDGING.md");
      return module.default as string;
    },
  },
  {
    name: "4_COMBAT",
    import: async () => {
      const module = await import("../rules/4_COMBAT.md");
      return module.default as string;
    },
  },
  {
    name: "5_RESTING",
    import: async () => {
      const module = await import("../rules/5_RESTING.md");
      return module.default as string;
    },
  },
  {
    name: "6_ITEMS_AND_ABILITIES",
    import: async () => {
      const module = await import("../rules/6_ITEMS_AND_ABILITIES.md");
      return module.default as string;
    },
  }
] as const;
